<div class="breadcrumbs hotel_banner bgwhite" style="padding-top: 80px">
    <div class="container">
        <div class="text-left breadcrumbs-item" style="padding-top: 20px; padding-bottom: 20px">
            <h2><span>Contact</span> US</h2>
            <div style="
          content: '';
          display: block;
          width: 150px;
          height: 3px;
          background: #06608c;
          border-radius: 25%;
          margin-top: 15px;
          margin-bottom: 5px;
        "></div>
        </div>
    </div>
</div>

<div class="main-body bgwhite" style="padding-bottom: 30px">
    <div class="container">
        <div class="map" style="box-shadow: 0 0 1px 2px #b2b2b27a; padding: 15px">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.315846372115!2d77.43033807444364!3d28.590300085999264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cee30657295f7%3A0x5f1b19d791a22f30!2sRAMDAS%20INFOTECH%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1699896993017!5m2!1sen!2sin"
                  width="100%" height="350" frameborder="0" style="border:0"
                  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div class="row" style="padding-top: 20px">
            <div class="col-md-8" style="box-shadow: 0 0 1px 2px #b2b2b27a; padding: 15px">
                <p>
                    If you have any questions regarding our products or services, please
                    contact us by calling or e-mailing us. We will get back to you as soon
                    as possible.
                </p>

                <form [formGroup]="form" (ngSubmit)="onSubmit()" method="post" action="#">
                    <!-- <div *ngIf="errorMessage" class="error-message">
                        {{ errorMessage }}
                      </div> -->
                    <div class="row">
                        <div class="col-md-6" style="padding-bottom: 10px">
                            <input #inp formControlName="firstname" type="text" class="form-control" placeholder="First Name" 
                            [class.is-invalid]="form.get('firstname')?.invalid && form.get('firstname')?.touched"/>
                            <div *ngIf="form.controls['firstname'].errors && form.controls['firstname'].touched"
                                class="error">
                                <div *ngIf="form.controls['firstname'].errors['required']"></div>
                                <div *ngIf="form.controls['firstname'].errors['pattern']"></div>
                                <div *ngIf="form.controls['firstname'].errors['minlength']"></div>
                                <div *ngIf="form.controls['firstname'].errors['maxlength']"></div>
                            </div>
                        </div>
                        <div class="col-md-6 mat-n-t" style="padding-bottom: 10px">
                            <input formControlName="lastname" type="text" class="form-control" placeholder="Last Name" 
                            [class.is-invalid]="form.get('lastname')?.invalid && form.get('lastname')?.touched"/>
                            <div *ngIf="form.controls['lastname'].errors && form.controls['lastname'].touched"
                                class="error">
                                <div *ngIf="form.controls['lastname'].errors['required']"></div>
                                <div *ngIf="form.controls['lastname'].errors['pattern']"></div>
                                <div *ngIf="form.controls['lastname'].errors['minlength']"></div>
                                <div *ngIf="form.controls['lastname'].errors['maxlength']"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row mar-t10">
                        <div class="col-md-6" style="padding-bottom: 10px">
                            <input formControlName="mobile" type="tel" class="form-control" placeholder="Mobile Number" 
                            [class.is-invalid]="form.get('mobile')?.invalid && form.get('mobile')?.touched"/>
                            <div *ngIf="form.controls['mobile'].invalid && form.controls['mobile'].touched"
                                class="error">
                                <div *ngIf="form.controls['mobile'].errors['pattern']"></div>
                                <div *ngIf="form.controls['mobile'].errors['required']"></div>
                            </div>
                        </div>
                        <div class="col-md-6 mat-n-t" style="padding-bottom: 10px">
                            <input formControlName="email" type="email" class="form-control" placeholder="Email " 
                            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"/>
                            <div *ngIf="form.controls['email'].invalid && form.controls['email'].touched"
                                class="error">
                                <div *ngIf="form.controls['email'].errors['email']"></div>
                                <div *ngIf="form.controls['email'].errors['required']"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row mar-t10">
                        <div class="col-md-12" style="padding-bottom: 10px">
                            <textarea formControlName="reply" type="text" class="form-control" cols="10" rows="3"
                                placeholder="Enter Your Message" [class.is-invalid]="form.get('reply')?.invalid && form.get('reply')?.touched">
                        </textarea>
                            <div *ngIf="form.controls['reply'].invalid && form.controls['reply'].touched"
                                class="error">
                                <div *ngIf="form.controls['reply'].errors['required']"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row mar-t10" style="padding-bottom: 10px">
                        <div class="col-md-12">
                            <button type="submit"  class="btn btn-primary"
                                name="submit-contact">
                                Submit Now
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-4" style="box-shadow: 0 0 1px 2px #b2b2b27a; padding: 15px">
                <h4 class="talk-head">Reach Us</h4>
                <ul class="list-unstyled mb-0">
                    <li style="
              padding-bottom: 4px;
              border-bottom: 2px solid #ffcd82;
              width: 48%;
            ">
                        <span style="width: 30px; display: table-cell; vertical-align: top"><i
                                class="fa fa-map text-secondaryf"></i></span>
                        <span style="
                display: table-cell;
                vertical-align: top;
                font-weight: 550;
                color: #085d86;
              ">INDIA BRANCH
                        </span>
                    </li>
                    <li>
                        <span style="width: 30px; display: table-cell; vertical-align: top"><i
                                class="fa fa-home mr-3 text-secondaryf"></i></span>
                        <span style="display: table-cell; vertical-align: top">{{Address}}</span>
                    </li>
                    <li>
                        <span><i
                                class="fa fa-envelope mr-3 fs-12 text-secondaryf"></i></span><span>{{ContactEmail}}</span>
                    </li>
                    <li>
                        <span style="width: 30px; display: table-cell; vertical-align: top"><i
                                class="fa fa-phone mr-3 text-secondaryf"></i></span><span style="display: table-cell; vertical-align: top">{{ContactNo}}</span>
                    </li>
                </ul>

                <!--<ul class="list-unstyled mb-0" style="margin-top: 15px;">
    <li style="padding-bottom: 4px;border-bottom: 2px solid #ffcd82;width: 60%;"><span style="width: 30px;display:table-cell;vertical-align: top;"><i class="fa fa-map text-secondaryf"></i></span>
    <span style="display:table-cell;vertical-align: top;font-weight: 550;COLOR: #085d86;">DALLAS Taxas(U.S) BRANCH </span></li>
    <li>
      <span style="width: 30px;display:table-cell;vertical-align: top;"><i class="fa fa-home mr-3 text-secondaryf"></i></span>
      <span style="display:table-cell;vertical-align: top;">4239 DARK STAR LANE,<br>  DALLAS Taxas 72511</span>
    </li>
</ul>-->
            </div>
        </div>
    </div>
</div>
